module.exports = __webpack_public_path__ + "img/img58.b624d30d.svg";